import { render, staticRenderFns } from "./ClassSessionDetails.vue?vue&type=template&id=5d824112&"
import script from "./ClassSessionDetails.vue?vue&type=script&lang=js&"
export * from "./ClassSessionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClassSessionDetails.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports